export const AUTH_RENEW_AUTORENEW_DELTA = 30 * 60 // 30 minutes
export const AUTH_RENEW_NOTICE_DELTA = 5 * 60 // 5 minutes
export const AUTH_RENEW_WARNING_DELTA = 1 * 60 // 1 minutes
